import { render, staticRenderFns } from "./ComPrivacyAgreement.vue?vue&type=template&id=55cf4db0&"
import script from "./ComPrivacyAgreement.vue?vue&type=script&lang=js&"
export * from "./ComPrivacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ComPrivacyAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports